module.exports = __webpack_public_path__ + "media/images/emoticons/confident-398d9fdefc4fd158e4e01782499afb8e.gif";